import { types } from 'actions/projects/msp_step_button_actions'

const initialState = {
  projects: [],
  steps: [],
  current: null,
  workflows: []
}

function reducer (state = initialState, action) {
  switch (action.type) {
    case types.INIT:
      return {
        ...state,
        projects: action.projects || [],
        steps: action.steps || [],
        current: action.current || null,
        workflows: action.workflows || []
      }
    case types.CREATE_MSP_PROJECT:
      return {
        ...state,
        projects: action.data.projects || []
      }
    case types.LOAD_MSP_PROJECT_STEPS:
      return {
        ...state,
        steps: action.data.steps || []
      }
  }
  return state
}

export default reducer
